import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';


const classes = {
    h1: {
        margin: 'auto',
        align: 'center',
        justify: 'center',
        color: '#009688',
        paddingBottom: 20,
        borderBottom: 'solid 0.02em',
        width: '40%',
        marginBottom: 60
    },
    p: {
        color: '#333333',
        marginTop: 30,
        marginBottom: 30
    },
}

const onMouseClickHandler = () => {
    window.location.href = 'https://www.kth.se/en/om/work-at-kth/lediga-jobb/what:job/jobID:297954/type:job/where:4/apply:1';
}

const onMouseClickHandlerPostdoc = () => {
    window.location.href = 'https://www.kth.se/en/om/work-at-kth/lediga-jobb/what:job/jobID:555636/type:job/where:4/apply:1';
}
const onMouseClickHandlerResearcher = () => {
    window.location.href = 'https://www.kth.se/en/om/work-at-kth/lediga-jobb/what:job/jobID:362229/where:4/';
}

const onMouseClickHandlerDoctoral = () => {
    window.location.href = 'https://www.kth.se/en/om/work-at-kth/lediga-jobb/what:job/jobID:386970/where:4/';
}

export default class Positions extends Component {
    render() {
        return (
            <div align="left" style={{ margin: '10%' }}>
                <Typography align="center" variant="h4" style={classes.h1}>Positions</Typography>
                <Typography style={classes.p}>
                    We are currently not hiring.

                </Typography>
              
    
                

               
            </div>
        )
    };
}